import inView from "./inView";

const lazyAnimated = () => {
  $(".js-animate").each(function () {
    let $el = $(this);
    if (inView($el) && !$el.hasClass("animated")) {
      $el.addClass("animated");
    }
  });
};

export default lazyAnimated;
